import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import withStyles from '@material-ui/core/styles/withStyles'

const styles = (theme) => ({
  thumbnail: {
    float: 'left',
    margin: '0 30px 10px',
    display: 'block',
    objectFit: 'cover',
    [theme.breakpoints.down('sm')]: {
      float: 'none',
      margin: 'auto',
      maxWidth: '100%',
      height: '100%',
      maxHeight: '100vh',
    },
  },
  downloadBtn: {
    color: '#fff',
    background: theme.palette.text.review,
    '&:hover': {
      background: theme.palette.primary.main,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.85em',
    },
  },
  title: {
    padding: 12,
    fontWeight: 600,
    color: theme.palette.primary.main,
    paddingTop: 10,
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.4em',
    },
  },
})

const OnePageFunnel = (props) => {
  const { header, html: body } = props
  return (
    <div>
      <Typography variant="headline" align="center">
        {header}
      </Typography>
      <Typography component="div" dangerouslySetInnerHTML={{ __html: body }} />
    </div>
  )
}

OnePageFunnel.propTypes = {
  slug: PropTypes.string.isRequired,
  html: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  header: PropTypes.string.isRequired,
  video: PropTypes.string.isRequired,
  landingUrl: PropTypes.string.isRequired,
  thumbnail: PropTypes.string.isRequired,
  bonus1: PropTypes.string,
  bonus2: PropTypes.string,
  bonus3: PropTypes.string,
  ending: PropTypes.string,
}

export default withStyles(styles)(OnePageFunnel)



// WEBPACK FOOTER //
// ./src/components/Landing/OnePageFunnel/index.js